<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Quiz Participants</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createnew">
                Add New
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>
        
        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="group" header="Quiz Group" />
        <PrimeColumn field="age" header="Age" />
        <PrimeColumn field="grade" header="Grade" />
        <PrimeColumn field="subject" header="Subject" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                <PrimeButton
                    label="Participants"
                    icon="pi-file-o"
                    class="p-button-rounded p-button-text"
                    @click="showGroups(slotProps.data)"
                />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="addParticipant"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>

</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref,computed} from 'vue';
import { useRouter, useRoute } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";

export default {
    name:"AcademicResults",
    components:{ModalView,DynamicForm},
    setup(){
        const route = useRoute();
        const groups=ref([])
        const qid = computed(() => route.params.id);
        const router = useRouter();
        //english,yoruba,mathematics, french,igbo, reading
        const state=reactive({loading:true,createModal:false,submitting:false,errors:[],success:false,
            subjects:[
                {label:"English",value:"English"},{label:"Mathematics",value:"Mathematics"},
                {label:"Yoruba",value:"Yoruba"},{label:"Igbo",value:"Igbo"},
                {label:"French",value:"French"},{label:"Reading",value:"Reading"},
            ]
         })
        const list = ref([])
        const globalFilter=ref("")
        onMounted(() => {
            call({
                url:urls.quiz,
                data:{startQuizP:qid.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        if (!Array.isArray(res.msg.list)) {
                            list.value = Object.values(res.msg.list)
                        } else {
                            list.value = res.msg.list
                        }
                        groups.value=[];
                        Object.keys(res.msg.groups).forEach(k => {
                            console.log("looping")
                            groups.value.push(res.msg.groups[k])
                        })
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });
        const createFields=ref([
            { name: "Create Group", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Name',
                        value: ""  },
                        { type: 'text', name: 'age', label: 'Age',
                        value: ""  },
                        { type: 'text', name: 'gender', label: 'Gender',
                        value: ""  },
                        { type: 'text', name: 'grade', label: 'Grade',
                        value: ""  },
                        { type: 'text', name: 'pname', label: 'Parent / Guardian Name',
                        value: ""  },
                        { type: 'text', name: 'relationship', label: 'Relationship to Child',
                        value: ""  },
                        { type: 'text', name: 'pphone', label: 'Primary Phone Number',
                        value: ""  },
                        { type: 'text', name: 'aphone', label: 'Alternative Phone Number',
                        value: ""  },
                        { type: 'text', name: 'email', label: 'Email',
                        value: ""  },
                        { type: 'text', name: 'country', label: 'Country',
                        value: ""  },
                        { type: 'password', name: 'pass', label: 'Password',
                        value: ""  },
                        { type: 'checkbox', name: 'subject', label: 'Subject',
                        value: "", values:state.subjects  },
                        { type: 'select', name: 'group', label: 'Group',
                        value: "", options:groups  },
                    {type: 'hidden', name:"qid", value:qid.value}
                ]
            }
        ])

        function createnew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
        }

        
        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        function addParticipant(data){
            state.submitting=true;
            state.errors=[];
            state.success=false;
            data.addParticipant="";
            call({
                url:urls.quiz,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function action(row,type){
            console.log(type, row)
            router.push({ name: 'resultsview', query: { stu: row.id, s:type } });
        }

        function showGroups(row){
            router.push({ name: 'quizgroup', params: { stu: row.id} });
        }
        
        return {list,globalFilter, state,action,createFields,createnew,addParticipant, showGroups}
    }
}
</script>